const Formatter = {
  /*
   * Applies the formatter for the specified string to the value
   * @params {string} format - The formatter to be applied
   * @params {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  apply (format, value) {
    return Formatter[format](value)
  },

  /*
   * Returns the formatted cpf cnpj
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  cpf_cnpj (val) {
    const tmp = Formatter.numbers(val)
    switch (tmp.length) {
      case 11:
        return Formatter.cpf(val)
      case 14:
        return Formatter.cnpj(val)
      default:
        return tmp
    }
  },

  /*
   * Returns the formatted cpf
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  cpf (val) {
    val = Formatter.numbers(val)

    if (val.length >= 9) val = val.substr(0, 9) + '-' + val.substr(9)

    if (val.length >= 6) val = val.substr(0, 6) + '.' + val.substr(6)

    if (val.length >= 3) val = val.substr(0, 3) + '.' + val.substr(3)

    return val
  },

  /*
   * Returns the formatted cnpj
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  cnpj (val) {
    val = Formatter.numbers(val)

    if (val.length >= 12) val = val.substr(0, 12) + '-' + val.substr(12)

    if (val.length >= 8) val = val.substr(0, 8) + '/' + val.substr(8)

    if (val.length >= 5) val = val.substr(0, 5) + '.' + val.substr(5)

    if (val.length >= 2) val = val.substr(0, 2) + '.' + val.substr(2)

    return val
  },

  /*
   * Returns a brazilian date. Eg.: 25/01/2018
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  date (val) {
    val = val.replace(/\D/g, '')

    if (val.length >= 4) val = val.substr(0, 4) + '/' + val.substr(4)

    if (val.length >= 2) val = val.substr(0, 2) + '/' + val.substr(2)

    return val
  },

  /*
   * Returns a brazilian date with a dot separator. Eg.: 25•01•2018
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  date_dot (val) {
    val = Formatter.date(val)

    val = val.replace(/\//g, '•')

    return val
  },

  /*
   * Returns a brazilian date with a dot separator. Eg.: 25.01.2018
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  date_period (val) {
    val = Formatter.date(val)

    val = val.replace(/\//g, '.')

    return val
  },

  /*
   * Returns the day in the specified date. Eg.: 24/01/2018 returns 24
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  day (val) {
    val = val.replace(/\D/g, '')

    if (val.length < 2) return ''

    return val.substr(0, 2)
  },

  /*
   * Returns the brazilian decimal form. Eg.: 1.000,00
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  decimal (val) {
    val = val.replace(/\D/g, '').replace(/^0+/, '')
    val = val.padStart(3, '0')

    if (val.length > 11) val = val.substr(0, val.length - 11) + '.' + val.substr(val.length - 11)

    if (val.length > 8) val = val.substr(0, val.length - 8) + '.' + val.substr(val.length - 8)

    if (val.length > 5) val = val.substr(0, val.length - 5) + '.' + val.substr(val.length - 5)

    if (val.length > 2) val = val.substr(0, val.length - 2) + ',' + val.substr(val.length - 2)

    return val
  },

  /* Removes all numbers */
  letters (val) {
    return val.replace(/[0-9]/g, '')
  },

  /*
   * Returns only the first letter of the person name inserted. Eg.: Lucas returns L
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  first_letter (val) {
    val = val.replace(/ /g, '')

    return val.substr(0, 1)
  },
  /*
   * Removes from the value anything that is not a number.
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  number (val) {
    return val.replace(/\D/g, '')
  },

  /*
   * Alias for 'number'
   */
  numbers (val) {
    return Formatter.number(val)
  },

  /*
   * Removes from the value anything that is not a number and adds a upperscript o.
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  ordinal_number (val) {
    return Formatter.numbers(val) + '&#186;'
  },

  /*
   * Returns a brazillian phone number (new or old) with the area code. Eg.: (31) 1234-5678 or (31) 12345-6789
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  phone (val) {
    val = val.replace(/\D/g, '')

    if (val.length < 11) return legacyPhone(val)

    return newPhone(val)

    function legacyPhone (val) {
      if (val.length >= 6) val = val.substr(0, 6) + '-' + val.substr(6)

      if (val.length >= 2) val = val.substr(0, 2) + ') ' + val.substr(2)

      if (val.length > 0) val = '(' + val

      return val
    }

    function newPhone (val) {
      return '(' + val.substr(0, 2) + ') ' + val.substr(2, 5) + '-' + val.substr(7)
    }
  },

  /*
   * Returns "anos" or "ano" depending on the child age.
   * @param {string} value - The age used to determine to plural form
   * @return {string} value - The text
   */
  short_age (val) {
    const age = Formatter.numbers(val)
    if (!age) return ''
    return Number(age) > 1 ? 'anos' : 'ano'
  },

  /*
   * Returns "aninhos" or "aninho" depending on the child age.
   * @param {string} value - The age used to determine to plural form
   * @return {string} value - The text
   */
  short_age_diminutive (val) {
    const age = Formatter.numbers(val)
    if (!age) return ''
    return Number(age) > 1 ? 'aninhos' : 'aninho'
  },

  /*
   * Removes all numbers from the value, keeping only the text, special characters and whitespace
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  text (val) {
    return val.replace(/\d/g, '').replace(/\s\s+/g, ' ').trim()
  },

  /*
  * Only allo users to uppercase the first letter of each word
  * @param {string} value - The value to be formatted
  * @return {string} value - The formatted value
  */
  titlecase (val) {
    const result = []

    val.split(' ').forEach((word) => {
      result.push(word.charAt(0) + word.slice(1).toLowerCase())
    })

    return result.join(' ')
  },

  /*
   * Returns the last 2 digits from year in the specified date. Eg.: 24/01/2018 returns 18
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  short_year (val) {
    val = val.replace(/\D/g, '')

    if (val.length < 8) return ''

    return val.substr(6, 2)
  },

  /*
   * Returns a brazilian zipcode. Eg.: 04521-004
   * @param {string} value - The value to be formatted
   * @return {string} value - The formatted value
   */
  zipcode (val) {
    val = val.replace(/\D/g, '')

    if (val.length >= 5) val = val.substr(0, 5) + '-' + val.substr(5)

    return val
  }
}

export default Formatter
